import React from "react";
import { renderToString } from "react-dom/server";
import PropTypes from "prop-types";
import { Link } from "react-router";
import cn from "classnames";
import ReviewsAgg from "marketing/containers/reviews_agg";
import StarRating from "common/components/star_rating";
import { MKT_CLIENTS_COUNT, MOBILE_BREAKPOINT_PX } from "common/variables";
import Slider from "common/components/slick_slider";

const REVIEWS = [
  {
    quote: renderToString(
      <>
        <span className="quote-highlight">Fantastic experience</span> - thank
        you for existing!{" "}
        <span className="quote-highlight">
          As a start-up, wasting time and money are two big fears
        </span>
        . What if I hire a designer and I don't like their design but am still
        obligated to pay? The risk feels too great.{" "}
        <span className="quote-highlight">
          Crowdspring has solved the problem brilliantly.
        </span>
      </>
    ),
    author: "Jennifer E.",
    extra: "BryteLearn",
  },
  {
    quote: renderToString(
      <>
        I love you guys and have used you across multiple projects and companies
        over the years. You are hands down{" "}
        <span className="quote-highlight">
          the best choice for logo and business card design
        </span>
        . Crowdspring was a brilliant idea. Most ideas, however, have poor
        execution. Crowdspring's execution has been phenomenal.{" "}
        <span className="quote-highlight">
          From the platform to the process to the quality of the designers, you
          have knocked it out of the ballpark.
        </span>
      </>
    ),
    author: "Rocco P.",
    extra: "FDLD Holdings, LLC",
  },
  {
    quote: renderToString(
      <>
        You've built an{" "}
        <span className="quote-highlight">
          amazing platform that I've used at pivotal moments in my career
        </span>{" "}
        for almost a decade - and{" "}
        <span className="quote-highlight">
          I've been more successful because of what YOUR TEAM has put out there
          in the world
        </span>
        . Thank you!
      </>
    ),
    author: "Khristian G.",
    extra: "Charlotte, NC",
  },
  {
    quote: renderToString(
      <>
        I had over 100 entries that were{" "}
        <span className="quote-highlight">
          creative, unique, and specific to my design ideas. I would absolutely
          recommend crowdspring
        </span>{" "}
        to any professional who doesn't have an in-office creative team.
      </>
    ),
    author: "Christina Catalano",
    extra: "CEO, Catalano & Associates",
  },
  {
    quote: renderToString(
      <>
        Crowdspring is{" "}
        <span className="quote-highlight">
          the ONLY place I go for outsourced art
        </span>
        . I love that I get 60+ different designs to choose from and always{" "}
        <span className="quote-highlight">ALWAYS walk away happy</span>. I think
        this was my 10th project on Crowdspring, and I'll definitely be back.
      </>
    ),
    author: "Asia B.",
    extra: "American Fork, UT",
  },
  {
    quote: renderToString(
      <>
        Crowdspring{" "}
        <span className="quote-highlight">
          takes the stress out of creating the perfect, one-of-a-kind logo for
          any business
        </span>
        . The artists are phenomenal, and the finished product is far better
        than anything I could imagine. This site is{" "}
        <span className="quote-highlight">
          outstanding in customer service and goes above and beyond to deliver
          the perfect product
        </span>
        .
      </>
    ),
    author: "Thomas B.",
    extra: "Hospitality Remodels",
  },
  {
    quote: renderToString(
      <>
        Crowdspring's army of creatives generated{" "}
        <span className="quote-highlight">
          thousands of ideas for naming our company
        </span>
        . Now, Zello is the most popular walkie-talkie app, with more than 100
        million registered users.
      </>
    ),
    author: "Bill Moore",
    extra: "CEO, Zello",
  },
  {
    quote: renderToString(
      <>
        This is the fourth time I have used Crowdspring for company logos, and
        have recommended you all to several of my friends over the last 10
        years.{" "}
        <span className="quote-highlight">
          Very few things are easy as they claim to be, but your process truly
          is.
        </span>
      </>
    ),
    author: "Michael H.",
    extra: "Gary, IN",
  },
  {
    quote: renderToString(
      <>
        Working with Crowdspring was, once again, a{" "}
        <span className="quote-highlight">hassle-free experience</span>. The
        platform continues to be{" "}
        <span className="quote-highlight">
          the go-to for sourcing talented creatives
        </span>
        , ultimately resulting in exceptional projects{" "}
        <span className="quote-highlight">at an affordable price</span> point.
      </>
    ),
    author: "Pierre M.",
    extra: "Rediform Inc.",
  },
  {
    quote: renderToString(
      <>
        The way you handle what the customer wants for his logo is absolutely
        incredible. This website earns my trust in seconds.{" "}
        <span className="quote-highlight">
          This website, the design team, and the customer service put the FUN in
          business!
        </span>
      </>
    ),
    author: "Mohammad E.",
    extra: "Kalamazoo, MI",
  },
  {
    quote: renderToString(
      <>
        <span className="quote-highlight">
          Super easy process and affordable.
        </span>{" "}
        I was{" "}
        <span className="quote-highlight">
          blown away by the number of high-quality designs I received
        </span>{" "}
        for my project. I chose four finalists and would have been happy with
        any of their designs as my final choice.
      </>
    ),
    author: "Kevin C.",
    extra: "Saint Paul, MN",
  },
];

const Reviews2 = ({
  stats,
  background,
  title,
  subtitle,
  reviews,
  cta = {},
}) => {
  return (
    <section className={cn("block block-reviews-2 thick", background)}>
      <div className="row columns small-16 text-center">
        <ReviewsAgg
          title={
            <h2>
              {title || (
                <>
                  From startups to giants, {MKT_CLIENTS_COUNT}+ businesses
                  worldwide can't be wrong
                </>
              )}
            </h2>
          }
          subtitle={(stats) =>
            subtitle || (
              <p>
                With a {stats.avg || 0}/5 rating, our clients consistently love
                what we do
              </p>
            )
          }
        />
      </div>
      <Slider
        infinite={false}
        slidesToShow={2}
        slidesToScroll={1}
        arrowsVersion="v1"
        responsive={[
          {
            breakpoint: MOBILE_BREAKPOINT_PX,
            settings: { slidesToShow: 1, dots: true },
          },
        ]}
      >
        {(reviews || REVIEWS).map((review, i) => (
          <div key={i}>
            <div className="review">
              <p>
                “<span dangerouslySetInnerHTML={{ __html: review.quote }} />”
              </p>

              <StarRating readonly={true} initialRate={5} />

              <div className="meta">
                {review.author}
                <br />
                {review.extra}
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className="row columns small-16">
        <Link
          to={cta.url || "/reviews/"}
          className="text-center as-h3-important"
        >
          {cta.label || (
            <>
              See what {(stats.count || 0).toLocaleString()}+ of our clients
              have to say
            </>
          )}
        </Link>
      </div>
    </section>
  );
};

Reviews2.propTypes = {
  stats: PropTypes.object.isRequired,
  background: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  reviews: PropTypes.array,
  cta: PropTypes.object,
};

export default Reviews2;
